module.exports = __webpack_public_path__ + "img/63.79ab1f13.png";